import React from 'react';
//import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {Tabs,Carousel} from 'antd';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
//import '../../assets/css/App.css';
import img1 from '../../assets/images/background.jpg';
import img2 from '../../assets/images/MIFA1.jpg';
import img3 from '../../assets/images/HC2.jpg';
const {
    Footer
  } = Layout;

class Mobile extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            
            <Tabs>
            <Tabs.TabPane tab='Ciitool' key='1' >
                 
                    <div style={{textAlign:"left" ,background: `url(${img1}) no-repeat center center`,height:"100%" ,position:"relative",backgroundSize: "cover",paddingLeft:20,paddingRight:20}}>
                    <div>
                    <br></br>
                        <txt style={{fontSize:26,fontWeight:"blod"}}>Welcome to the Ciitool Platform! <br></br></txt>
                        <txt style={{fontSize:20,}}><br></br>Here is a brief introduction to the platform for mobile users. All the modules should be accessed through the personal computer: www.ciitool.com.</txt> 
                        <br></br>
                        <br></br>
                        <txt style={{fontSize:20}}>Based on medical imaging analysis, the Ciitool Platform is dedicated to providing accurate and reliable suggestions for clinicians and patients. Our ultimate goal is to promote the level of cure of human cancer by exploring knowledge of medical imaging.</txt> 
                        <br></br>
                        <br></br>
                    </div>
                    </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab='Module-MIFA' key='2'>
                    <div style={{paddingRight:10,paddingLeft:10}}><txt style={{fontSize:18,paddingRight:10,paddingLeftL:10}}>The primary aim of medical image feature atlas (MIFA) is to propose a specification image feature altas for each of the cancer-related problem, suggesting future medical image studies on human cancers.</txt></div>
                    <div><img src={img2} style={{height:"100%" ,width:"100%" ,position:"relative",backgroundSize: "cover",}}/></div>
                 </Tabs.TabPane>
                 <Tabs.TabPane tab='Module-HCC' key='3'>
                 <div style={{paddingRight:10,paddingLeft:10}}><txt style={{fontSize:18,}}>The Hepatocellular Carcinoma Module can provide quantitative preoperative and postoperative clinical efficacy evaluation of transcatheter arterial chemoembolization (TACE) therapy for patients with hepatocellular carcinoma. </txt></div>
                 <div><img src={img3} style={{height:"100%" ,width:"100%" ,position:"relative",backgroundSize: "cover",}}/></div>
                 </Tabs.TabPane>
                 <Tabs.TabPane tab='Disclaimer' key='4'>
                 <div style={{textAlign:"left" ,background: `url(${img1}) no-repeat center center`,height:"100%" ,position:"relative",backgroundSize: "cover",paddingLeft:20,paddingRight:20}}>
                 <br></br>  
                 <div style={{paddingRight:10,paddingLeft:10}}><txt style={{fontSize:18,}}>This platform is for non-commercial use, and the analysis results provided are for auxiliary clinical use only. All actual clinical decisions and potential risks are the responsibility of clinicians or patients themselves. All use of the analysis results of this platform for commercial purposes without the permission of the owner of the platform will be subject to legal liability. </txt></div>
                 <br></br>
                        <br></br>
                 </div>
                   </Tabs.TabPane>
                    </Tabs>
                     

        )
    }
}
export default Mobile;